import React from "react";
import { Table, TableBody, TablePagination } from "@mui/material";

import AllActiveOffersTableHead from "../TableHeads/AllOffersTableHead";
import AllOffersTableRow from "../TableRows/AllOffersTableRow";

const AllOffersTable = ({
    count,
    fetchedActiveCarOffers,
    rowsPerPage,
    page,
    onRowSelect,
    onPageChange,
    onRowsPerPageChange,
}) => {
    return (
        <div style={styles.tablePaddingDiv}>
            <div style={styles.tableBorderDiv}>
                <Table sx={{ minWidth: 900, width: "100%" }}>
                    <AllActiveOffersTableHead />
                    <TableBody>
                        {fetchedActiveCarOffers.map((offer) => (
                            <AllOffersTableRow
                                key={offer.part_offer_id}
                                carOffers={offer}
                                onSelect={() => onRowSelect(offer.part_offer_id)}
                            />
                        ))}
                    </TableBody>
                </Table>

                <TablePagination
                    rowsPerPageOptions={[15, 25, 50]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                />
            </div>
        </div>
    );
};

export default AllOffersTable;

const styles = {
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        width: "100%",
        overflowX: "auto",
    },
};
